<pre class="feedback-container">
  <p>If you have any feedback/bugs to report, please send them here</p>
  @if (!feedbackSent) {
    <div class="main-container">
      <textarea type="text" #feedbackInput class="feedback-text-area"></textarea>
      <button type="button"  class="lw-gradient-text lw-main-btn btn btn-lg btn-primary" [disabled]="btnDisabled" (click)='submit(feedbackInput.value)'>Submit</button>
    </div>
  }
  @if (feedbackSent) {
    <p>Thank you for submitting your feedback.</p>
  }
  @if (feedbackError) {
    <p>There was an error sending your feedback, please try again</p>
  }
</pre>
